<div class="drop-down" appClickOutside (clickOutside)="onClickedOutside()">
  <button
    type="button"
    class="drop-down-box"
    [class.is-invalid]="!isValid"
    [class.drop-down-box-open]="!listClosed"
    [class.is-disable]="isDisable"
    [ngClass]="buttonClass"
    (click)="openDropDown()"
  >
    <span>{{ selectedItem.friendlyName }}</span>
    <i class="fas fa-angle-down"></i>
  </button>
  <div  class="drop-down-fields-box" *ngIf="!listClosed">
    <div class="search-box-top">
      <input
        class="form-control search-input change-arrow-key"
        type=" text"
        #SearchInput
        [(ngModel)]="searchBox"
        [placeholder]="'search' | translate"
        (keyup)="searchOnItems()"
      />
      <button
        type="button"
        *ngIf="searchBox != '' && searchBox != null"
        (click)="emptySearch()"
      >
        <i class="far fa-times-circle"></i>
      </button>
    </div>

    <div class="items-list px-2 py-1 change-arrow-key" *ngFor="let item of showData">
      <button type="button" (click)="selectItem(item)">
        <span>{{ item.friendlyName }}</span>
      </button>
    </div>

    <div class="add-box" *ngIf="addUrl">
      <input
        class="form-control change-arrow-key"
        type=" text"
        [placeholder]="'add' | translate"
        [(ngModel)]="NewName"
      />
      <button type="button" (click)="addButton()">
        <i class="far fa-plus-square"></i>
      </button>
    </div>
  </div>
  <app-loading-panel *ngIf="loading"></app-loading-panel>
</div>
